import { render, staticRenderFns } from "./ParsersData.vue?vue&type=template&id=87a17316"
import script from "./ParsersData.vue?vue&type=script&lang=js"
export * from "./ParsersData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports